<template>
  <div class="cart-item">
    <div class="cart-item__top font-size-xxs">
      <div v-if="!cartItem.isLocked" class="d-flex ml-auto">
        <div class="d-flex align-items-center ml-2 font-weight-bold">
          {{ i18n.change_order_and_startDate }}
        </div>

        <button
          type="button"
          class="btn btn--primary btn--sm btn--icon-only ml-2 mr-3"
          @click="() => setModalIsOpen(true)"
          data-toggle="tooltip"
          data-placement="top"
          :title="i18n.adjustJourneyOrder"
        >
          <Icon name="sort" extra-classes="icon--xl" />
        </button>
      </div>
    </div>

    <div class="cart-item__body border p-3 p-xl-4 w-100">
      <div class="row">
        <div class="col-md-3 mb-3 mb-md-0">
          <div class="cart-item__image position-relative">
            <div class="cart-item__number">
              {{ index }}
            </div>

            <div class="position-relative overflow-hidden ratio--4-3">
              <img
                :src="cartItem.image"
                alt=""
                class="img-fit absolute-center lazyload"
                loading="lazy"
              >
            </div>
          </div>
        </div>

        <div class="col-md-9 pl-md-2">
          <div class="cart-item__content">
            <h2 class="h3 color-text-dark font-weight-bold mb-0 pr-md-5 pr-xl-6">
              {{ cartItem.title }}
            </h2>

            <div v-if="cartItem.location">
              <div class="d-flex font-size-xxs mt-3">
                <Icon name="pin" extra-classes="mr-1" /> {{ cartItem.location }}
                <span class="d-flex align-items-center ml-3">
                    <Icon name="calendar" extra-classes="color-mute" class="mr-1" />
                    {{`${cartItem.dateOfArrival} - ${cartItem.dateOfDeparture}`}}
                </span>
              </div>
            </div>

            <div v-if="!cartItem.isLocked" class="d-flex align-items-center mt-3">
              <div class="custom-select custom-select--small">
                <select
                  class="form-control"
                  :id="`${cartItem.id}-nights`"
                  required
                  disabled
                >
                  <option :value="cartItem.amountOfNights">
                    {{ cartItem.amountOfNights }}
                  </option>
                </select>

                <Icon name="arrow-down" />
              </div>

              <label :for="`${cartItem.id}-nights`" class="form-label color-text-dark text-lowercase ml-3 mb-0">
                {{ i18n.nights }}
              </label>
            </div>

            <RoomSelect :cart-item="cartItem" />

            <CartItemRooms v-if="cartItem.roomOptions" :cart-item="cartItem" />

            <CartItemOptions v-if="cartItem.options" :cart-item="cartItem" />

            <CartItemExperiences v-if="cartItem.experiences" :cart-item="cartItem" />
          </div>
        </div>
      </div>

      <button
        class="media-item__remove btn"
        type="button"
        @click="() => removeCartItem(cartItem.id)"
      >
        <Icon name="trash" />
        <span class="sr-only">{{ i18n.remove_item }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Icon from '@/cart/components/Icon.vue';
import RoomSelect from '@/cart/components/RoomSelect.vue';
import CartItemRooms from '@/cart/components/CartItemRooms.vue';
import CartItemOptions from '@/cart/components/CartItemOptions.vue';
import CartItemExperiences from '@/cart/components/CartItemExperiences.vue';

export default {
  components: {
    Icon,
    RoomSelect,
    CartItemRooms,
    CartItemOptions,
    CartItemExperiences,
  },

  props: {
    cartItem: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
      default: 1,
    },

    showTravelOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    ...mapActions([
      'removeCartItem',
    ]),

    ...mapMutations([
      'setModalIsOpen',
    ]),
  },

  mounted() {
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
};
</script>
